/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TermsAndConditionsAgreement/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckboxWithInputText from 'DesignSystem/TysiaCheckboxWithInputText/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'



/** @type {import('Simple/types.js').View} */
export default function TermsAndConditionsAgreement({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectDevelopers/CreateToken/Content/Create/TermsAndConditionsAgreement",
  onChange
  
}) {
let createTokenAcceptedTermsAndConditionsValueData = fromData.useDataValue({ viewPath,
context: 'create_token',
path: 'acceptedTermsAndConditions',
})
let createTokenAcceptedTermsAndConditionsChangeData = fromData.useDataChange({ viewPath,
context: 'create_token',
path: 'acceptedTermsAndConditions',
})
  return (<React.Fragment
>
<TysiaCheckboxWithInputText
  viewPath={`${viewPath}/TysiaCheckboxWithInputText`}
 text="I understand that by generating an API token, I am creating a credential that grants access to my data within the Greyfinch Platform, which may include HIPAA-protected, sensitive, or private information. I acknowledge that I am responsible for how this token is used, whether by myself or others with whom I share it. I certify that I am authorized to create this token and share this information. I have read and agree to the terms and conditions outlined in the Master Services Agreement, available at:"
 data="create_token.acceptedTermsAndConditions"
 onChange={createTokenAcceptedTermsAndConditionsChangeData}
 value={createTokenAcceptedTermsAndConditionsValueData}
/>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 marginLeft={26}
 text="greyfinch.com/master-services-agreement"
 goTo="https://greyfinch.com/master-services-agreement"
/>
{children}
</React.Fragment>)
}